import React, { useEffect, useState, forwardRef } from "react";
import { useSelector } from "react-redux";

import { CustomSelect } from "../../common/customSelect/CustomSelect";
import { catalogSelectors } from "../../catalogs/_core/catalogSelectors";
import { cartSelectors } from "../../cart/_core/cartSelectors";


export const AddressHouseSelectInput = forwardRef(({
  value, style, styles, disabled, onChange = () => {
  }, onMenuClose, autoFocus
}, ref) => {
  const houses = useSelector(catalogSelectors.houses).valueSeq().toArray();
  const housesLoading = useSelector(catalogSelectors.housesLoading);
  const address = useSelector(cartSelectors.address);
  const [ selectedHouse, setSelectedHouse ] = useState({
    value: value ? value.value : address?.houseId,
    label: value ? value.label : address?.house,
  });

  useEffect(() => {
    setSelectedHouse({
      value: value ? value.value : address?.houseId,
      label: value ? value.label : address?.house,
    });
  }, [ address.street, address.house, address.houseId, value, value?.value, value?.label ]);

  const handleHouseChange = (newValue) => {
    onChange(newValue);
    setSelectedHouse({ value: newValue.value, label: newValue.label });
  };


  return (
    <CustomSelect 
            ref={ref}
            options={houses}
            styles={styles || style}
            value={selectedHouse}
            isDisabled={disabled || housesLoading}
            isLoading={housesLoading}
            onChange={handleHouseChange}
            onMenuClose={onMenuClose}
            autoFocus={autoFocus}
            placeholder=" "
						filterOption={({label}, input) => {
							if (!input) return true;
							return label.includes(input);
						}}
            noOptionsMessage={() => ``}/>
  )
});
